<template>

  <div class="module-case">

    <Header @clicked="open_menu" @searching="buscarFronHeader" :counter_data="[]"/>

    <div class="module-dashboard-b">
      <Split class="module-split" :gutterSize="4">

          <SplitArea :size="40" v-show="!show_current_item" class="m-split-l">

            <div class="m-split-l-row">

              <div class="row m-0 module-case-subtitle-container">
                
                <span type="text" class="form-control module-case-subtitle">{{ module_subtitle }}</span>

                <a class="text-dark" style="align-self: center;margin-left: auto;margin-right: 5px;" href="#" 
                  @click="main_items_loading || main_new()">
                  <feather type="plus" style="height: 19px !important;"></feather>
                </a>

                <!--<a class="text-dark" style="align-self: center;margin-left: 10px;margin-right: 5px;" href="#" 
                  @click="open_filter()">
                  <feather type="filter" style="height: 16px !important;"></feather>
                </a>-->
                
              </div>

              <div class="d-lg-none" style="padding: 0px 10px 5px;">
                <div class="main-items-subsearch d-flex">
                  <i class="fa fa-search"></i>
                  <input class="form-control-plaintext" v-on:keyup="buscar" 
                  v-model="busqueda" type="text" placeholder="Buscar..." :disabled="main_items_loading">
                </div>
              </div>
              
              <div class="row m-0">

                <VuePerfectScrollbar class="main-items-height-991" style="width: 100%;">

                  <VclBulletList class="m-4" :rows="4" v-if="main_items_loading"></VclBulletList>
                  
                  <b-list-group class="main_list" v-if="!main_items_loading">
                    <b-list-group-item style="cursor: pointer;color: #9a9a9a;display: inline-flex;border-right-color: transparent !important;border-left-color: transparent !important;" tag="a" 
                      v-for="main_item in main_items" :key="main_item.id" :disabled="current_main_item_loading"
                      v-on:click="main_show(main_item)" :class="[ current_main_item.id == main_item.id ? 'active' : '']">

                      <div class="initials_user_container">
                        <span class="initials_user">
                          {{ getIniciales(main_item.nombre,main_item.apellido) }}
                        </span>
                      </div>
                      <div class="form-row form-scroll m-0" style="width: 100%;display: flex !important;flex-wrap: wrap !important;width: calc(100% - 100px);">
                        <div class="col-sm-12 main_item_label">
                          {{ main_item.nombre + ' ' + main_item.apellido }}
                        </div>
                        <div style="font-family: nunito !important;margin-top: 3px;padding-right: 5px;padding-left: 5px;font-size: 12px;display: inline-block;overflow: hidden !important;width: 100%;white-space: nowrap;text-overflow: ellipsis;color: #888ea8;font-weight: 600;text-transform: lowercase;">
                          <span class="col-sm-12" 
                            style="font-family: nunito !important;margin-top: 3px;padding: 5px 0px !important;">
                            {{ main_item.mail }}
                          </span>
                        </div>  

                      </div>
                      <div class="main_item_date">
                        {{ date_to_label(main_item.created_at) }}
                      </div>
                    
                    </b-list-group-item>
                  </b-list-group>
                  
                </VuePerfectScrollbar>

              </div>

              <div class="main_table table-responsive datatable-vue m-0 vue-smart" >
                <v-data-table :items="main_items" style="border: none !important;"
                  :total-items="main_items_count" :pagination.sync="main_pagination" item-key="id" 
                  rows-per-page-text="Registros por página" :rows-per-page-items='[25]'>
                    <template slot="headers" style="cursor: pointer">
                    </template>
                    <template slot="items" style="cursor: pointer">
                    </template>
                </v-data-table>
              </div>
            </div>

          </SplitArea>

          <SplitArea :size="60" v-show="!mobile_mode || show_current_item" :class="'m-split-r' + ((mobile_mode && !show_current_item)?(' d-none'):(''))">

            <div class="m-split-r-row">

              <div class="col-md-12" style="padding: 0px 25px;" v-if="current_main_item.id == undefined && !current_main_item_loading">
                <!--<span style="font-size: 33px;text-align: center;color: #80808054;margin: 80px 20px;font-family: nunito;display: block;">
                  [ Seleccione un caso ]
                </span>-->
              </div>

              <VclTable class="m-4" :rows="1" :columns="3" v-if="current_main_item_loading"></VclTable>
              <VclList class="m-4" v-if="current_main_item_loading"></VclList>
              
              <b-tabs class="main_tabs" content-class="m-0" v-if="current_main_item.id != undefined">

                <b-tab active>

                  <template v-slot:title>
                    <i class="fa fa-info tab-icon"></i> <span class="tab-title">General</span>
                  </template>

                  <div class="row p-0 m-0">
                    
                    <VuePerfectScrollbar class="main-item-height-991" style="width: 100%;">

                      <div class="col-lg-12 module-section">

                        <div class="row m-0">
                          <span class="module_sub_title">
                            Datos del Usuario
                          </span>
                        </div>

                        <div class="card" style="box-shadow: none;margin-bottom: 0px !important;">
                          <div class="card-body" style="padding: 0px !important;">
                         
                            <div class="custom-scroll-bar-wrap">
                              <div class="row notifiaction-media mr-0 ml-0">
                                <div class="col-md-6 mb-0" style="padding: 0px 10px !important;" v-for="ea in entity_attributes" :key="ea.cs_model">
                                  <b-form-group class="dynamic_form" :disabled="current_main_item_loading" :label="ea.cs_label.replace('_',' ') + ':'">
                                    <b-form-checkbox v-if="ea.cs_component === 'checkbox'" v-model="ea.cs_value" value="t" unchecked-value="f" disabled switch size="md">
                                    </b-form-checkbox>
                                    <label v-if="ea.cs_component != 'checkbox'" class="module_form_label_2">{{ ea.cs_value }}</label>
                                  </b-form-group>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </VuePerfectScrollbar>

                  </div>

                </b-tab>

                <template v-slot:tabs-end>
                  <div class="row m-0 module-options">

                    <b-button v-if="edit_usuario" @click="main_edit" 
                      v-b-tooltip.hover.top="'Editar'"
                      :disabled="current_main_item_loading" class="btnModuleRight d-none d-lg-flex" variant="light">
                      <i class="fa fa-edit"></i></b-button>

                    <!--<b-button v-if="show_action_button_delete" @click="main_delete" 
                      v-b-tooltip.hover.top="'Anular'"
                      :disabled="current_main_item_loading" class="btnModuleRight d-none d-lg-flex" variant="light">
                      <i class="fa fa-trash-o"></i></b-button>-->
                      
                    <div class="onhover-dropdown d-block d-lg-none">
                      <div class="media align-items-center" style="height: 100%;">
                        <b-button :disabled="current_main_item_loading" class="btnModuleRight d-flex d-lg-none" variant="light">
                          <i class="fa fa-ellipsis-v"></i></b-button>
                      </div>
                      <ul class="menu-dropdown onhover-show-div p-3" style="width:200px !important;">

                        <li class="option" v-if="edit_usuario" @click="main_edit"><a>Editar</a></li>
                        <li class="separador" v-if="edit_usuario"></li>

                        <li class="separador" v-if="show_action_button_delete"></li>
                        <!--<li class="option"  v-if="show_action_button_delete" @click="main_delete"><a style="color: red;">Anular</a></li>-->
                      </ul>
                    </div>

                    <b-button v-if="show_current_item" @click="main_close" 
                      v-b-tooltip.hover.top="'Cerrar'"
                      :disabled="current_main_item_loading" class="btnModuleRight d-flex d-lg-none" variant="light">
                      <i class="fa fa-times" style="font-size: 20px;color: #414a5d !important;"></i>
                    </b-button>

                  </div>
                </template>

              </b-tabs>

            </div>

          </SplitArea>

      </Split>
    </div>

    <UsuarioNew ref="UsuarioNew" v-on:closeModal="closeModalMainNew" :key="MainNewRandomKey"/>
    <UsuarioUpdate ref="UsuarioUpdate" v-on:closeModal="closeModalMainUpdate" :key="MainUpdateRandomKey"/>
    <UsuarioAdminUpdate ref="UsuarioAdminUpdate" v-on:closeModal="closeModalMainNewAdmin" :key="UsuarioAdminUpdateRandomKey"/>
 
  </div>

</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import Header from '../../header'
import { mapState } from "vuex";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
const Swal = require('sweetalert2')
import UsuarioNew from './UsuarioNew'  
import UsuarioUpdate from './UsuarioUpdate'
import UsuarioAdminUpdate from './UsuarioAdminUpdate'
import { VclBulletList } from 'vue-content-loading';
import { VclTable } from 'vue-content-loading';
import { VclList } from 'vue-content-loading';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'

export default {
  components: {
    Header,
    VuePerfectScrollbar,
    UsuarioNew,
    UsuarioUpdate,
    UsuarioAdminUpdate,
    VclBulletList,
    VclTable,
    VclList,
    BeatLoader
  },
  computed: {
    ...mapState({
      filtros: state => state.main_filters,
      loading: state => state.main_loading
    }),
    show_action_button_delete () {
      return true;
    },
    edit_usuario () { 
      return true;
    }
  },
  watch: {
    filtros: {
      handler () {
        if (this.filtros.work_group_id != undefined) {
          this.main_refresh()
        }
      },
      deep: true
    },
    main_pagination: {
      handler () {
        if (this.main_items.length > 0) {
          this.main_refresh()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      model: "user",
      module_subtitle: "Usuarios",
      user_info: {},
      main_items: [],
      busqueda: undefined,
      main_items_count: 0,      
      current_main_item: {},
      current_main_item_original: {},      
      main_pagination: { rowsPerPage: 25 },
      mobile_mode: false,
      show_current_item: false,

      permissions: {},

      MainNewRandomKey: 0,
      MainUpdateRandomKey: 100,
      UsuarioAdminUpdateRandomKey: 1000,

      main_items_loading: false,
      current_main_item_loading: false,
      entity_attributes: []
    }
  },
  mounted() {
    try {
      if (!localStorage.signedIn) {
        this.$router.push('/')
      } else {

        if (window.innerWidth < 991) {
          this.mobile_mode = true
        } else {
          this.mobile_mode = false
        }

        this.user_info = JSON.parse(localStorage.userinfo)

        //valido permisos
        var accesos = JSON.parse(localStorage.accesos)
        accesos.forEach(acceso => {
          if(acceso.model == this.model){
            this.permissions[acceso.permission] = true
          }
        });

        this.$store.dispatch("main_filters/setModuleName", this.model);

        if (localStorage.time_zone == "") {
          this.$bvModal.show("UsuarioAdminUpdate")
        }

      }
    } catch (error) {
      this.showError(error)
    } 
  },
  methods: {
    open_menu () {
      this.$emit('clicked', true)
    },
    open_filter () {
      this.$store.dispatch("main_loading/openFilter");
    },
    buscarFronHeader (text) {
      this.busqueda = text
      this.main_refresh()
    },
    buscar (event) {
      if (event.code == "Enter" || event.code == "NumpadEnter") {
        this.main_refresh()
      } 
    },
    main_refresh () {

      this.main_items_loading = true
      this.$store.dispatch("main_loading/startLoading");

      this.current_main_item = {}
      this.current_main_item_original = {}

      var data = {}
      data.limit = this.main_pagination.rowsPerPage
      data.page = this.main_pagination.page
      data.ascending = !this.main_pagination.descending
      data.orderBy = this.main_pagination.sortBy
      data.query = {
        buscar: this.busqueda,
        enable: this.filtros.enable
      }

      this.getUsuarios_rows(data)
      .then(data => {
        this.main_items_loading = false
        this.$store.dispatch("main_loading/stopLoading");
        this.main_items = data.items
        this.main_items_count = data.total        
      })

    },
    main_new () {
      this.$refs.UsuarioNew.init();
      this.$bvModal.show("UsuarioNew")
    },    
    main_show (main_item, force, on_update) {

      if (main_item.id != this.current_main_item.id || force) {
        this.current_main_item_loading = true
        this.current_main_item = {}
        this.current_main_item_original = {}
        
        this.getUsuarioForView(main_item.id)
          .then(data => {

            this.current_main_item_loading = false

            if (data) {
              
              this.entity_attributes = []
              
              for (let key in data.usuario){
                if(data.usuario.hasOwnProperty(key)){
                  if (key != "id" && key != "updated_at" && key != "created_at" &&
                        key != "v2_environment_id" &&
                        key != "password_expire_lastdate" &&
                        key != "password_expire_days" &&
                        key != "password_expire" &&
                        key != "internal_name" &&
                        key != "first_login" &&
                        key != "userid" &&
                        key != "validate_email_token" &&
                        key != "avatar"
                      ) {
                    this.entity_attributes.push({cs_label: key.replace(/_/g," "), cs_value: data.usuario[key]})
                  }
                }
              }

              this.current_main_item = data.usuario
              this.current_main_item_original = JSON.parse(JSON.stringify(data.usuario))
              
              if (on_update) {
                this.main_items.forEach(element => {
                  if (element.id == this.current_main_item.id) {
                    element.nombre = data.usuario.nombre
                    element.apellido = data.usuario.apellido
                    element.mail = data.usuario.mail
                  }    
                });
              }
              
            }

          })        
      }

      if (window.innerWidth < 991) {
        this.show_current_item = true
        this.mobile_mode = true
      } else {
        this.mobile_mode = false
      }

    },
    main_close () {
      this.show_current_item = false
    },
    main_edit () {
      this.$refs.UsuarioUpdate.setId(this.current_main_item.id);
      this.$bvModal.show("UsuarioUpdate")
    },
    closeModalMainNew () {
      this.main_refresh()
      this.MainNewRandomKey +=1
    },
    closeModalMainNewAdmin () {
      this.main_refresh()
      this.UsuarioAdminUpdateRandomKey +=1
    },
    closeModalMainUpdate (item) {
      this.main_show(this.current_main_item, true, true)      
      this.MainUpdateRandomKey +=1
    },
    main_delete () {
      try {

        Swal.fire({
          title: 'Está seguro?',
          text: "Se eliminará este usuario",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3ea1d3',
          cancelButtonColor: '#f37979',
          confirmButtonText: 'Sí, eliminarlo!'
        }).then((result) => {
          if (result.value) {

            this.$http.secured.get('/auth/v1/users/'+ this.current_main_item.v2_empresa_id +'/v2_productos/', { params: { type: "eliminarProducto", v2_producto_id: this.current_main_item.id } })
            .then(response => {
              this.main_refresh();
              this.showOK("Se eliminó correctamente!")
            })
            .catch(error => {
                this.showError(error)
              }
            )
          }
        })
      } catch (error) {
        this.showError(error)
      }
    }
  }
}
</script>
